import TimeSheetTabContent from './TimeSheetTabContent';

const ToBeCompletedContent = () => (
  <TimeSheetTabContent status="0" emptyStateType="time_sheet_to_be_completed" />
);

export default ToBeCompletedContent;
